import * as ko from 'knockout'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import Guard from '../../../../AppUtils/Framework/Guard'
import type { ObservableFinisher } from '../../../Model/Observables/ObservableFinisher'

export class FinisherPricesViewModel extends Disposable {
  public finisher!: ObservableFinisher
  public showToteWin!: ko.PureComputed<boolean>
  public showFobWin!: ko.PureComputed<boolean>
  public showSpWinDividend!: ko.Computed<boolean>
  public displaySpWinDividend!: ko.Computed<string>
  public shouldShowFixedFavourite!: ko.Computed<boolean>

  constructor(params: { finisher: ObservableFinisher }) {
    super()

    Guard.notNull(params.finisher)

    this.finisher = params.finisher

    this.showSpWinDividend = ko.pureComputed<boolean>(() => this.finisher.spWinPrice() > 0)
    this.displaySpWinDividend = ko.pureComputed<string>(() => this.finisher.spWinPrice().toFixed(2))

    this.showToteWin = ko.pureComputed<boolean>((): boolean => {
      return (
        this.finisher.placing() === 1 ||
        this.finisher.toteWinDiv() > 0 ||
        this.finisher.isCountBack()
      )
    })

    this.showFobWin = ko.pureComputed<boolean>((): boolean => {
      return this.finisher.placing() === 1
    })

    this.shouldShowFixedFavourite = ko.pureComputed<boolean>(
      () => this.finisher.hasFixedOdds() && this.finisher.fixedOddsFinisherInfo.isFavourite()
    )
  }
}
